// extracted by mini-css-extract-plugin
export default {"this":"Lugares_this__sl6MT"};